import { useEffect } from "react";

function useScrollReveal() {
  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const threshold = isMobile ? 0.2 : 0.5;

    const items = document.querySelectorAll(".scroll-reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    items.forEach((item) => observer.observe(item));
    return () => observer.disconnect();
  }, []);
}

export default useScrollReveal;